<template>
  <div class="archive-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="page-title-group">
        <div class="page-title">车辆管理</div>
        <div class="page-subtitle">
          运力资源池 · 监管上报字段已对齐《数字货运综合服务平台对接文档》2.3
          服务方信息上报
        </div>
      </div>
      <div class="page-actions">
        <button
          v-if="getLimit('vehicleArchive_export_button')"
          class="btn btn-export"
          type="button"
          @click="handleExport"
        >
          导出
        </button>
        <button
          v-if="getLimit('vehicleArchive_add_button')"
          class="btn btn-primary"
          type="button"
          @click="goDetailNew"
        >
          ＋ 新增车辆
        </button>
      </div>
    </div>

    <!-- 筛选面板 -->
    <div class="filter-bar">
      <div class="filter-row">
        <div class="filter-item filter-item-keyword">
          <label>车牌号 / 实际承运人姓名</label>
          <input
            v-model.trim="listQuery.keyword"
            type="text"
            placeholder="车牌号或实际承运人姓名"
          />
        </div>
        <div class="filter-item filter-item-keyword">
          <label>手机号</label>
          <input
            v-model.trim="listQuery.driverPhone"
            type="text"
            placeholder="手机号"
          />
        </div>
        <div class="filter-item">
          <label>审核状态</label>
          <select v-model="listQuery.authStatus">
            <option value="">全部</option>
            <option
              v-for="item in authStatusOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item">
          <label>车辆类型</label>
          <select v-model="listQuery.classificationCode">
            <option value="">全部</option>
            <option
              v-for="item in classificationOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item">
          <label>车长</label>
          <select v-model="listQuery.carLength">
            <option value="">全部</option>
            <option
              v-for="item in carLengthOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item filter-item-energy">
          <label>能源类型</label>
          <el-select
            v-model="listQuery.energyType"
            class="energy-multi"
            multiple
            collapse-tags
            clearable
            placeholder="全部"
            size="small"
          >
            <el-option
              v-for="item in energyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="filter-item filter-item-sm">
          <label>是否牵引车</label>
          <select v-model="listQuery.isTractor">
            <option value="">全部</option>
            <option
              v-for="item in isTractorOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item filter-item-sm">
          <label>是否4.5吨以下</label>
          <select v-model="listQuery.isLight45">
            <option value="">全部</option>
            <option
              v-for="item in isLight45Options"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-actions">
          <button class="btn btn-query" type="button" @click="handleSearch">
            查询
          </button>
          <button
            class="btn btn-plain"
            type="button"
            @click="batchPlateDialogVisible = true"
          >
            多车牌号查询
          </button>
          <button class="btn btn-plain" type="button" @click="handleReset">
            重置
          </button>
          <button
            type="button"
            class="filter-adv-toggle"
            :class="{ 'is-open': advancedOpen }"
            @click="toggleAdvanced"
          >
            <span>{{ advancedOpen ? "收起筛选" : "高级筛选" }}</span>
            <svg
              class="adv-chev"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </div>
      </div>
      <div
        v-show="advancedOpen"
        class="filter-row filter-row-bordered filter-adv-row"
      >
        <div class="filter-item filter-item-range">
          <label>注册时间</label>
          <el-date-picker
            v-model="listQuery.regRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="value => changeDate(value, 'reg')"
          />
        </div>
        <div class="filter-item filter-item-range">
          <label>审核时间</label>
          <el-date-picker
            v-model="listQuery.authRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="value => changeDate(value, 'auth')"
          />
        </div>
        <div class="filter-item">
          <label>审核人</label>
          <input
            v-model.trim="listQuery.authPerson"
            type="text"
            placeholder="审核人"
          />
        </div>
        <div class="filter-item">
          <label>上报状态</label>
          <select v-model="listQuery.reportStatus">
            <option value="">全部</option>
            <option
              v-for="item in reportStatusOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item">
          <label>车辆状态</label>
          <select v-model="listQuery.vehicleStatus">
            <option value="">全部</option>
            <option
              v-for="item in vehicleStatusOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item">
          <label>是否入网</label>
          <select v-model="listQuery.netStatus">
            <option value="">全部</option>
            <option
              v-for="item in netStatusOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
        <div class="filter-item">
          <label>经营类型</label>
          <select v-model="listQuery.vehicleNature">
            <option value="">全部</option>
            <option
              v-for="item in natureOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</option
            >
          </select>
        </div>
      </div>
    </div>

    <!-- 运力资源池卡片 -->
    <div class="vehicle-card">
      <div class="vehicle-card-top">
        <div class="vehicle-card-title">运力资源池</div>
        <div class="vehicle-card-count">
          共 <strong>{{ formatNumber(listQuery.total) }}</strong> 条，已选
          <strong>{{ selected.length }}</strong> 条
        </div>
        <div class="vehicle-card-tools">
          <button
            v-if="getLimit('vehicleArchive_onNet_button')"
            class="btn btn-plain btn-batch-onnet"
            type="button"
            :disabled="batchOnNetLoading || !batchOnNetRows.length"
            @click="handleBatchOnNet"
          >
            <i v-if="batchOnNetLoading" class="el-icon-loading" />
            批量入网
          </button>
          <button
            class="btn btn-plain btn-refresh"
            type="button"
            @click="findList"
          >
            <i class="el-icon-refresh" />刷新
          </button>
        </div>
      </div>

      <div class="table-shell">
        <div v-loading="loading" class="table-scroll">
          <table class="data-table">
            <colgroup>
              <col style="width: 44px" />
              <col style="width: 144px" />
              <col style="width: 152px" />
              <col style="width: 84px" />
              <col style="width: 78px" />
              <col style="width: 94px" />
              <col style="width: 96px" />
              <col style="width: 64px" />
              <col style="width: 88px" />
              <col style="width: 232px" />
              <col style="width: 84px" />
              <col style="width: 136px" />
              <col style="width: 106px" />
            </colgroup>
            <thead>
              <tr>
                <th class="col-check">
                  <input
                    ref="headerCheckHead"
                    class="cb-table"
                    type="checkbox"
                    :checked="isPageAllSelected"
                    @change="toggleSelectAll"
                  />
                </th>
                <th>车牌号码</th>
                <th>车辆所有人</th>
                <th>车型/车长</th>
                <th>能源类型</th>
                <th>当前实际承运人</th>
                <th>所属区域</th>
                <th>载重状态</th>
                <th>车辆定位</th>
                <th>证件到期</th>
                <th>审核状态</th>
                <th>管理信息</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in tableData"
                :key="row.code"
                :class="rowClass(row)"
              >
                <td>
                  <input
                    class="cb-table"
                    type="checkbox"
                    :checked="rowSelected(row)"
                    :disabled="rowCancelled(row)"
                    @change="toggleSelectRow(row)"
                  />
                </td>
                <td>
                  <div class="cell-pair">
                    <div
                      class="cell-main cell-main--plate"
                      :title="row.licenseNumber"
                    >
                      <span
                        v-if="row.licenseNumber"
                        class="plate-badge"
                        :class="plateClass(row)"
                        >{{ row.licenseNumber }}</span
                      >
                      <span v-else>--</span>
                      <span
                        v-if="rowFrozen(row) || rowCancelled(row)"
                        class="plate-state-col"
                      >
                        <span
                          v-if="rowFrozen(row)"
                          class="state-mark is-frozen"
                          title="已冻结"
                          >冻结</span
                        >
                        <span
                          v-if="rowCancelled(row)"
                          class="state-mark is-cancelled"
                          title="已注销"
                          >注销</span
                        >
                      </span>
                    </div>
                    <div v-if="row.vehicleTypeName" class="cell-sub">
                      {{ row.vehicleTypeName }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="cell-pair">
                    <div class="cell-main" :title="row.owner">
                      {{ row.owner || "--" }}
                    </div>
                    <div v-if="row.ownerTypeName" class="cell-sub">
                      {{ row.ownerTypeName }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="cell-pair cell-pair--emph">
                    <div class="cell-main" :title="row.modelName">
                      {{ row.modelName || "--" }}
                    </div>
                    <div v-if="row.lengthName" class="cell-sub">
                      {{ row.lengthName }}
                    </div>
                  </div>
                </td>
                <td>
                  <span class="energy-tag" :class="energyTone(row)">{{
                    row.energyTypeName || "--"
                  }}</span>
                </td>
                <td>
                  <div class="cell-pair cell-pair--emph">
                    <div class="cell-main" :title="row.driverName">
                      {{ row.driverName || "--" }}
                    </div>
                    <div v-if="row.driverPhone" class="cell-sub">
                      {{ row.driverPhone }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="cell-region" :title="row.regionText">
                    {{ row.regionText || "--" }}
                  </div>
                </td>
                <td>
                  <span class="cell-load" :class="loadCls(row)">{{
                    row.loadStatusName || "--"
                  }}</span>
                </td>
                <td>
                  <div class="cell-gps">
                    <div class="gps-line">
                      <i class="gps-dot" :class="netDotCls(row)" />
                      <span>{{ netText(row) }}</span>
                      <span v-if="row.terminalNumber" class="gps-mini mini-ok"
                        >北斗</span
                      >
                    </div>
                  </div>
                </td>
                <td>
                  <div class="cert-list">
                    <div
                      v-for="c in certRows(row)"
                      :key="c.name"
                      class="cert-row"
                    >
                      <span class="cert-name">{{ c.name }}</span>
                      <span class="cert-date">{{ c.date }}</span>
                      <span class="cert-days" :class="c.tone">{{
                        c.daysText
                      }}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="auth-tag" :class="authTagCls(row)"
                    ><i class="auth-dot" />{{ authStatusLabel(row) }}</span
                  >
                </td>
                <td>
                  <div class="mgmt-cell">
                    <div class="mgmt-row">
                      <span class="mgmt-label">注册：</span>
                      <span class="mgmt-value">{{
                        fmtDate(row.regTime) || "--"
                      }}</span>
                    </div>
                    <div class="mgmt-row">
                      <span class="mgmt-label">审核：</span>
                      <span class="mgmt-value">{{
                        fmtDate(row.authTime) || "--"
                      }}</span>
                    </div>
                    <div class="mgmt-row">
                      <span class="mgmt-label">操作：</span>
                      <span class="mgmt-value">{{
                        row.authPerson || "--"
                      }}</span>
                    </div>
                  </div>
                </td>
                <td class="cell-actions">
                  <div class="cell-actions-rows">
                    <div class="cell-actions-row">
                      <button
                        v-if="getLimit('vehicleArchive_detail_button')"
                        class="text-action-btn primary"
                        type="button"
                        @click="goDetail(row)"
                      >
                        详情
                      </button>
                      <button
                        v-if="
                          !rowCancelled(row) &&
                            getLimit('vehicleArchive_edit_button')
                        "
                        class="text-action-btn"
                        type="button"
                        @click="goEdit(row)"
                      >
                        编辑
                      </button>
                    </div>
                    <div class="cell-actions-row">
                      <button
                        v-if="
                          !rowCancelled(row) &&
                            getLimit('vehicleArchive_freeze_button')
                        "
                        class="text-action-btn"
                        type="button"
                        @click="handleRowMore(row, freezeCommand(row))"
                      >
                        {{ freezeText(row) }}
                      </button>
                      <el-dropdown
                        v-if="showRowMoreActions(row)"
                        trigger="click"
                        @command="cmd => handleRowMore(row, cmd)"
                      >
                        <button
                          class="text-action-btn action-more"
                          type="button"
                        >
                          更多<i class="el-icon-arrow-down action-more-arrow" />
                        </button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-if="getLimit('vehicleArchive_audit_button')"
                            command="audit"
                            >审核</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="
                              getLimit('vehicleArchive_onNet_button') &&
                                canOnNet(row)
                            "
                            command="net"
                            >入网</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="getLimit('vehicleArchive_log_button')"
                            command="log"
                            >操作日志</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="getLimit('vehicleArchive_delete_button')"
                            command="del"
                            class="op-danger"
                            >删除</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!loading && !tableData.length">
                <td class="empty-cell" colspan="13">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pagination">
          <span class="pagination-info"
            >共 {{ formatNumber(listQuery.total) }} 条记录</span
          >
          <button
            class="pagination-btn"
            :class="{ disabled: listQuery.pageNum <= 1 }"
            type="button"
            @click="gotoPage(listQuery.pageNum - 1)"
          >
            上一页
          </button>
          <button
            v-for="p in pagerPages"
            :key="p"
            class="pagination-btn"
            :class="{ active: p === listQuery.pageNum }"
            type="button"
            @click="gotoPage(p)"
          >
            {{ p }}
          </button>
          <button
            class="pagination-btn"
            :class="{ disabled: listQuery.pageNum >= totalPages }"
            type="button"
            @click="gotoPage(listQuery.pageNum + 1)"
          >
            下一页
          </button>
          <select
            :value="listQuery.pageSize"
            class="pagination-size"
            @change="onSizeChange"
          >
            <option v-for="s in pageSizeOptions" :key="s" :value="s"
              >{{ s }}条/页</option
            >
          </select>
          <div class="pagination-jump">
            前往
            <input
              v-model="jumpPage"
              type="text"
              @keyup.enter="onJump"
              @blur="onJump"
            />
            页
          </div>
        </div>
      </div>
    </div>

    <!-- 车辆审核弹窗 -->
    <el-dialog
      :visible.sync="auditDialogVisible"
      title="车辆审核"
      width="480px"
      :close-on-click-modal="false"
    >
      <div class="audit-context">
        <span class="audit-context-label">车牌号</span>
        <span class="audit-context-value">{{ auditForm.plate }}</span>
      </div>
      <el-radio-group v-model="auditForm.authStatus" class="audit-radio-group">
        <el-radio :label="3">审核通过</el-radio>
        <el-radio :label="2">审核驳回</el-radio>
      </el-radio-group>
      <div v-if="auditForm.authStatus === 2" class="audit-reason">
        <div class="audit-reason-title">驳回原因</div>
        <el-input
          v-model="auditForm.authMsg"
          type="textarea"
          :rows="4"
          placeholder="请填写驳回原因"
        />
      </div>
      <span slot="footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="actionLoading" @click="submitAudit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 操作日志弹窗 -->
    <el-dialog :visible.sync="operLogVisible" title="操作日志" width="900px">
      <vehicle-oper-log
        v-if="operLogVisible"
        :code="operLogRow && operLogRow.code"
      />
    </el-dialog>

    <!-- 多车牌号查询弹窗 -->
    <el-dialog
      title="批量输入车牌号"
      :visible.sync="batchPlateDialogVisible"
      width="650px"
      :close-on-click-modal="false"
      class="batch-plate-dialog"
    >
      <batch-vehicle-plate
        :codes="listQuery.licenseNumbers"
        @confirmBatchInput="confirmBatchPlate"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  getVehicleArchiveList,
  auditVehicle,
  freezeVehicleArchive,
  unfreezeVehicleArchive,
  onNetVehicleArchive,
  batchOnNetVehicleArchive,
  deleteVehicleArchive,
  exportVehicleArchive
} from "@/api/vehicleArchive";
import { getListDict } from "@/api/commonApi";
import { download } from "@/utils";
import archiveKeepAlive from "@/mixins/archiveKeepAlive";
import VehicleOperLog from "./components/VehicleOperLog.vue";
import BatchVehiclePlate from "./components/BatchVehiclePlate.vue";

// 操作列 el-dropdown 指令常量（handleRowMore 集中分发）
const ROW_MORE_COMMANDS = {
  audit: "audit",
  net: "net",
  freeze: "freeze",
  unfreeze: "unfreeze",
  log: "log",
  del: "del"
};

export default {
  name: "VehicleArchive",
  components: { VehicleOperLog, BatchVehiclePlate },
  mixins: [archiveKeepAlive],
  data() {
    return {
      loading: false,
      actionLoading: false,
      batchOnNetLoading: false,
      operLogVisible: false,
      operLogRow: null,
      batchPlateDialogVisible: false,
      advancedOpen: false,
      tableData: [],
      selected: [],
      pageSizeOptions: [10, 20, 50],
      jumpPage: 1,
      listQuery: {
        keyword: "",
        licenseNumbers: "",
        driverPhone: "",
        authStatus: "",
        authPerson: "",
        classificationCode: "",
        carLength: "",
        energyType: [],
        vehicleStatus: "",
        reportStatus: "",
        netStatus: "",
        isTractor: "",
        vehicleNature: "",
        isLight45: "",
        regRange: "",
        regStart: "",
        regEnd: "",
        authRange: "",
        authStart: "",
        authEnd: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        sortField: "",
        sortOrder: ""
      },
      // 字典选项
      classificationOptions: [],
      energyOptions: [],
      carLengthOptions: [],
      // 状态枚举（文案与后端 /dict 一致）
      authStatusOptions: [
        { value: 0, label: "未审核" },
        { value: 1, label: "审核中" },
        { value: 2, label: "审核未通过" },
        { value: 3, label: "审核通过" }
      ],
      vehicleStatusOptions: [
        { value: "normal", label: "正常" },
        { value: "freeze", label: "已冻结" },
        { value: "cancel", label: "已注销" }
      ],
      reportStatusOptions: [
        { value: 0, label: "未上报" },
        { value: 1, label: "已上报" },
        { value: 2, label: "上报失败" }
      ],
      netStatusOptions: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
      isTractorOptions: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
      natureOptions: [
        { value: 1, label: "自有车" },
        { value: 2, label: "挂靠车" },
        { value: 3, label: "租赁车" },
        { value: 4, label: "承包车" }
      ],
      isLight45Options: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
      // 审核弹窗
      auditDialogVisible: false,
      auditForm: {
        code: "",
        plate: "",
        authStatus: 3,
        authMsg: ""
      }
    };
  },
  computed: {
    selectableRows() {
      return (this.tableData || []).filter(row => !this.rowCancelled(row));
    },
    isPageAllSelected() {
      const rows = this.selectableRows;
      return rows.length > 0 && rows.every(row => this.rowSelected(row));
    },
    isPagePartialSelected() {
      if (this.isPageAllSelected) {
        return false;
      }
      return this.selectableRows.some(row => this.rowSelected(row));
    },
    // 已勾选中「可入网（未入网且未注销）」的车辆
    batchOnNetRows() {
      return (this.selected || []).filter(row => this.canOnNet(row));
    },
    totalPages() {
      const total = Number(this.listQuery.total) || 0;
      const size = Number(this.listQuery.pageSize) || 20;
      return Math.max(1, Math.ceil(total / size));
    },
    pagerPages() {
      const current = Number(this.listQuery.pageNum) || 1;
      const total = this.totalPages;
      if (total <= 7) {
        const list = [];
        for (let i = 1; i <= total; i++) list.push(i);
        return list;
      }
      const span = 7;
      let start = current - 3;
      start = Math.max(1, Math.min(start, total - span + 1));
      const list = [];
      for (let i = 0; i < span; i++) list.push(start + i);
      return list;
    }
  },
  watch: {
    tableData() {
      this.$nextTick(() => this.syncIndeterminate());
    },
    selected() {
      this.$nextTick(() => this.syncIndeterminate());
    }
  },
  created() {
    this.findList();
    this.loadDict();
  },
  methods: {
    // ---------- 字典 ----------
    loadDict() {
      getListDict({
        types:
          "vehicleClassification,vehicleEnergyType,vehicleLicenseColor,app_vehicleLength"
      })
        .then(response => {
          const list = (response && response.data) || [];
          this.classificationOptions = this.pickDict(
            list,
            "vehicleClassification"
          );
          this.energyOptions = this.pickDict(list, "vehicleEnergyType");
          this.carLengthOptions = this.pickDict(list, "app_vehicleLength");
        })
        .catch(() => {});
    },
    pickDict(list, type) {
      const group = list.find(item => item.type === type);
      const dictList = (group && group.dictList) || [];
      // 后端会按 remark 扩展出同 code 的多条记录，这里按 code 合并去重，避免下拉选项 key 重复
      const optionMap = new Map();
      dictList.forEach(item => {
        if (!optionMap.has(item.code)) {
          optionMap.set(item.code, { value: item.code, label: item.name });
        }
      });
      return Array.from(optionMap.values());
    },
    // ---------- 列表 ----------
    findList() {
      this.loading = true;
      const params = Object.assign({}, this.listQuery);
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (
          value === null ||
          value === undefined ||
          value === "" ||
          (Array.isArray(value) && value.length === 0)
        ) {
          delete params[key];
        }
      });
      // 日期区间控件值（xxxRange）仅用于回显，实际查询下发 xxxStart / xxxEnd
      delete params.regRange;
      delete params.authRange;
      // 能源类型支持多选：数组转逗号串（后端按 find_in_set 匹配）
      if (Array.isArray(params.energyType)) {
        params.energyType = params.energyType.join(",");
      }
      return getVehicleArchiveList(params)
        .then(response => {
          const data = (response && response.data) || {};
          this.tableData = data.records || [];
          this.listQuery.total = data.total || 0;
          if (data.pageNum) {
            this.listQuery.pageNum = data.pageNum;
          }
          if (data.pageSize) {
            this.listQuery.pageSize = data.pageSize;
          }
          this.jumpPage = this.listQuery.pageNum;
          this.selected = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    // 多车牌号查询：确认后按车牌号精确查询（逗号分隔下发后端）
    confirmBatchPlate(plates) {
      const list = Array.isArray(plates) ? plates : [];
      if (!list.length) {
        this.$message.warning("请输入车牌号");
        return;
      }
      if (list.length > 300) {
        this.$message.warning("车牌号数量不能超过300个");
        return;
      }
      this.listQuery.licenseNumbers = list.join(",");
      this.batchPlateDialogVisible = false;
      this.handleSearch();
    },
    handleReset() {
      Object.assign(this.listQuery, {
        keyword: "",
        licenseNumbers: "",
        driverPhone: "",
        authStatus: "",
        authPerson: "",
        classificationCode: "",
        carLength: "",
        energyType: [],
        vehicleStatus: "",
        reportStatus: "",
        netStatus: "",
        isTractor: "",
        vehicleNature: "",
        isLight45: "",
        regRange: "",
        regStart: "",
        regEnd: "",
        authRange: "",
        authStart: "",
        authEnd: ""
      });
      this.listQuery.pageNum = 1;
      this.selected = [];
      this.findList();
    },
    reloadList() {
      this.findList();
    },
    resetAndReload() {
      this.handleReset();
    },
    toggleAdvanced() {
      this.advancedOpen = !this.advancedOpen;
    },
    // 日期区间：与运单管理一致，拆分为 Start / End 两个查询字段
    changeDate(value, prefix) {
      if (value) {
        this.listQuery[`${prefix}Start`] = value[0];
        this.listQuery[`${prefix}End`] = value[1];
      } else {
        this.listQuery[`${prefix}Start`] = "";
        this.listQuery[`${prefix}End`] = "";
      }
    },
    // ---------- 分页 ----------
    gotoPage(page) {
      const target = Number(page) || 1;
      const next = Math.max(1, Math.min(target, this.totalPages));
      if (next === Number(this.listQuery.pageNum)) {
        return;
      }
      this.listQuery.pageNum = next;
      this.findList();
    },
    onSizeChange(e) {
      const size = Number(e && e.target && e.target.value);
      if (!size || size === Number(this.listQuery.pageSize)) {
        return;
      }
      this.listQuery.pageSize = size;
      this.listQuery.pageNum = 1;
      this.findList();
    },
    onJump() {
      const raw = String(this.jumpPage == null ? "" : this.jumpPage).trim();
      if (!/^\d+$/.test(raw)) {
        return;
      }
      const page = Number(raw);
      if (page < 1 || page > this.totalPages) {
        return;
      }
      this.gotoPage(page);
    },
    // ---------- 行选择 ----------
    rowSelected(row) {
      if (!row) return false;
      return this.selected.some(item => item.code === row.code);
    },
    syncIndeterminate() {
      const partial = this.isPagePartialSelected;
      if (this.$refs.headerCheckHead) {
        this.$refs.headerCheckHead.indeterminate = partial;
      }
    },
    toggleSelectRow(row) {
      if (!row || this.rowCancelled(row)) return;
      if (this.rowSelected(row)) {
        this.selected = this.selected.filter(item => item.code !== row.code);
      } else {
        this.selected = this.selected.concat([row]);
      }
    },
    toggleSelectAll() {
      const rows = this.selectableRows;
      if (!rows.length) return;
      if (this.isPageAllSelected) {
        const codes = {};
        rows.forEach(row => {
          codes[row.code] = true;
        });
        this.selected = this.selected.filter(item => !codes[item.code]);
      } else {
        const exist = {};
        this.selected.forEach(item => {
          exist[item.code] = true;
        });
        const merged = this.selected.slice();
        rows.forEach(row => {
          if (!exist[row.code]) {
            merged.push(row);
          }
        });
        this.selected = merged;
      }
    },
    // ---------- 行状态 ----------
    rowCancelled(row) {
      return !!(row && Number(row.cancelledFlag) === 1);
    },
    rowFrozen(row) {
      return !!(row && Number(row.freezeFlag) === 1);
    },
    rowRejected(row) {
      return !!(row && Number(row.authStatus) === 2);
    },
    rowClass(row) {
      const classes = [];
      if (this.rowRejected(row)) {
        classes.push("row-rejected");
      }
      if (this.rowSelected(row)) {
        classes.push("row-selected");
      }
      return classes.join(" ");
    },
    authTagCls(row) {
      const map = {
        0: "tag-red",
        1: "tag-blue",
        2: "tag-orange",
        3: "tag-green"
      };
      return map[Number(row.authStatus)] || "tag-gray";
    },
    authStatusLabel(row) {
      if (row.authStatusText) {
        return row.authStatusText;
      }
      const item = this.authStatusOptions.find(
        item => item.value === Number(row.authStatus)
      );
      return item ? item.label : "--";
    },
    // 新能源判定：优先按能源类型名称关键词（含“电”，兼容字典名“电”），
    // 其次按小型新能源号牌格式（省+字母+[DF]+5位，8 位，普通牌无此形态）
    isNewEnergy(row) {
      const name = (row && row.energyTypeName) || "";
      if (/电动|混合|燃料|氢|新能源|电/.test(name)) {
        return true;
      }
      return this.isNewEnergyPlate(row && row.licenseNumber);
    },
    isNewEnergyPlate(licenseNumber) {
      const text = String(licenseNumber || "").toUpperCase();
      return /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][DF][A-HJ-NP-Z0-9]{5}$/.test(
        text
      );
    },
    // 能源类型标签配色：新能源绿 / 天然气·汽油蓝 / 其余灰
    energyTone(row) {
      if (this.isNewEnergy(row)) {
        return "tone-green";
      }
      const name = (row && row.energyTypeName) || "";
      if (/天然气|汽油/.test(name)) {
        return "tone-blue";
      }
      return "tone-gray";
    },
    // 车牌配色：新能源绿牌 / 其余黄牌
    plateClass(row) {
      return this.isNewEnergy(row) ? "plate-green" : "plate-yellow";
    },
    // 载重状态配色：负载主色 / 空载灰
    loadCls(row) {
      return Number(row.loadStatus) === 1 ? "is-loaded" : "is-empty";
    },
    // 定位：已入网=在线，未入网=离线
    netText(row) {
      return Number(row.netStatus) === 1 ? "已入网" : "未入网";
    },
    netDotCls(row) {
      return Number(row.netStatus) === 1 ? "online" : "offline";
    },
    // 证件到期行（仅车头：行驶证 / 道运证 / 经营许可证；经营许可证无有效期显示“未填写”）
    certRows(row) {
      const defs = [
        { name: "行驶证", value: row.vehicleLicenseDueDate },
        { name: "道运证", value: row.roadTransportCertificateDate },
        { name: "经营许可证", value: row.periodValidity, emptyText: "未填写" }
      ];
      const rows = [];
      defs.forEach(def => {
        if (def.value) {
          rows.push(this.buildCertRow(def.name, def.value));
        } else if (def.emptyText) {
          rows.push({
            name: def.name,
            date: def.emptyText,
            tone: "",
            daysText: "—"
          });
        }
      });
      return rows;
    },
    buildCertRow(name, value) {
      const parsed = this.parseCertDate(value);
      if (!parsed) {
        return { name, date: String(value), tone: "ok", daysText: "—" };
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const days = Math.floor(
        (parsed.date.getTime() - today.getTime()) / 86400000
      );
      let tone = "ok";
      if (days < 0) {
        tone = "bad";
      } else if (days <= 30) {
        tone = "warn";
      }
      return {
        name,
        date: parsed.text,
        tone,
        daysText: days < 0 ? "已过期" : days + "天"
      };
    },
    // 取文本中最后一个日期（兼容 yyyy-MM-dd / yyyy/MM/dd / yyyy年M月d日 及区间）
    parseCertDate(value) {
      if (!value) {
        return null;
      }
      const matches = String(value).match(/\d{4}\D\d{1,2}\D\d{1,2}/g);
      if (!matches || !matches.length) {
        return null;
      }
      const m = matches[matches.length - 1].match(
        /(\d{4})\D(\d{1,2})\D(\d{1,2})/
      );
      const date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      if (isNaN(date.getTime())) {
        return null;
      }
      const pad = n => (Number(n) < 10 ? "0" + Number(n) : "" + Number(n));
      return { date, text: m[1] + "-" + pad(m[2]) + "-" + pad(m[3]) };
    },
    canOnNet(row) {
      return !!row && !this.rowCancelled(row) && Number(row.netStatus) !== 1;
    },
    showRowMoreActions(row) {
      if (this.rowCancelled(row)) {
        return false;
      }
      return (
        this.getLimit("vehicleArchive_audit_button") ||
        this.getLimit("vehicleArchive_delete_button") ||
        this.getLimit("vehicleArchive_log_button") ||
        (this.getLimit("vehicleArchive_onNet_button") && this.canOnNet(row))
      );
    },
    freezeText(row) {
      return this.rowFrozen(row) ? "解冻" : "冻结";
    },
    freezeCommand(row) {
      return this.rowFrozen(row)
        ? ROW_MORE_COMMANDS.unfreeze
        : ROW_MORE_COMMANDS.freeze;
    },
    // ---------- 日期与数字 ----------
    fmtDate(v) {
      if (!v) return "";
      const s = String(v);
      if (/^\d{4}[-/]\d{2}[-/]\d{2}/.test(s)) {
        return s.slice(0, 10);
      }
      return s;
    },
    formatNumber(n) {
      const str = String(Number(n) || 0);
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // ---------- 跳转详情 ----------
    goDetail(row) {
      if (!row || !row.code) {
        return this.$message.warning("车辆编码缺失，无法查看详情");
      }
      this.$router.push({
        path: "/vehicleArchiveDetail",
        query: { code: row.code, edit: "0" }
      });
    },
    goEdit(row) {
      if (!row || !row.code) {
        return this.$message.warning("车辆编码缺失，无法编辑");
      }
      this.$router.push({
        path: "/vehicleArchiveDetail",
        query: { code: row.code, edit: "1" }
      });
    },
    goDetailNew() {
      this.$router.push({
        path: "/vehicleArchiveDetail",
        query: { edit: "new" }
      });
    },
    // ---------- 行更多操作分发 ----------
    // 行级按钮权限码（与后端 sys_resource.permission 一致，无权限直接隐藏）：
    // vehicleArchive_detail_button / vehicleArchive_edit_button / vehicleArchive_freeze_button
    // vehicleArchive_audit_button / vehicleArchive_onNet_button / vehicleArchive_log_button
    // vehicleArchive_delete_button / vehicleArchive_export_button / vehicleArchive_add_button
    handleRowMore(row, cmd) {
      switch (cmd) {
        case ROW_MORE_COMMANDS.audit:
          this.openAuditDialog(row);
          break;
        case ROW_MORE_COMMANDS.net:
          this.handleOnNet(row);
          break;
        case ROW_MORE_COMMANDS.freeze:
          this.handleFreeze(row);
          break;
        case ROW_MORE_COMMANDS.unfreeze:
          this.handleUnfreeze(row);
          break;
        case ROW_MORE_COMMANDS.log:
          this.handleOperLog(row);
          break;
        case ROW_MORE_COMMANDS.del:
          this.handleDelete(row);
          break;
        default:
          break;
      }
    },
    // ---------- 操作日志 ----------
    handleOperLog(row) {
      if (!row || !row.code) {
        return this.$message.warning("车辆编码缺失，无法查看操作日志");
      }
      this.operLogRow = { ...row };
      this.operLogVisible = true;
    },
    // ---------- 审核 ----------
    openAuditDialog(row) {
      if (!row || !row.code) {
        return this.$message.warning("车辆编码缺失，无法审核");
      }
      this.auditForm = {
        code: row.code,
        plate: row.licenseNumber || "--",
        authStatus: 3,
        authMsg: ""
      };
      this.auditDialogVisible = true;
    },
    submitAudit() {
      if (this.auditForm.authStatus === 2 && !this.auditForm.authMsg) {
        return this.$message.warning("审核驳回时请填写驳回原因");
      }
      this.actionLoading = true;
      const rLoading = this.openLoading("正在提交审核...");
      const authMsgList =
        this.auditForm.authStatus === 2 && this.auditForm.authMsg
          ? [{ 驳回原因: this.auditForm.authMsg }]
          : [];
      auditVehicle({
        code: this.auditForm.code,
        authStatus: this.auditForm.authStatus,
        authMsgList: authMsgList
      })
        .then(response => {
          rLoading.close();
          this.actionLoading = false;
          this.auditDialogVisible = false;
          this.$message({
            message: (response && response.msg) || "审核成功",
            type: "success"
          });
          this.findList();
        })
        .catch(() => {
          rLoading.close();
          this.actionLoading = false;
        });
    },
    // ---------- 冻结 / 解冻 / 入网 ----------
    handleFreeze(row) {
      this.$confirm(
        "确认冻结该车辆吗？冻结后车辆将暂停营运与监管上报。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          const rLoading = this.openLoading("正在冻结...");
          freezeVehicleArchive(row.code)
            .then(response => {
              rLoading.close();
              this.$message({
                message: (response && response.msg) || "冻结成功",
                type: "success"
              });
              this.findList();
            })
            .catch(() => {
              rLoading.close();
            });
        })
        .catch(() => {});
    },
    handleUnfreeze(row) {
      this.$confirm("确认解除冻结该车辆吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading("正在解冻...");
          unfreezeVehicleArchive(row.code)
            .then(response => {
              rLoading.close();
              this.$message({
                message: (response && response.msg) || "解冻成功",
                type: "success"
              });
              this.findList();
            })
            .catch(() => {
              rLoading.close();
            });
        })
        .catch(() => {});
    },
    handleOnNet(row) {
      this.$confirm("确认验证吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading("正在入网验证...");
          onNetVehicleArchive(row.code)
            .then(response => {
              rLoading.close();
              this.$message({
                message: (response && response.msg) || "入网成功",
                type: "success"
              });
              this.findList();
            })
            .catch(() => {
              rLoading.close();
            });
        })
        .catch(() => {});
    },
    // 批量入网：对勾选的未入网车辆逐台发起入网验证
    handleBatchOnNet() {
      const rows = this.batchOnNetRows;
      if (!rows.length) {
        this.$message.warning("请先勾选未入网的车辆");
        return;
      }
      this.$confirm(
        `确认对已勾选的 ${rows.length} 辆未入网车辆发起入网验证吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.batchOnNetLoading = true;
          const codes = rows.map(item => item.code);
          batchOnNetVehicleArchive(codes)
            .then(response => {
              const data = (response && response.data) || {};
              const successCount = Number(data.successCount) || 0;
              const failCount = Number(data.failCount) || 0;
              if (failCount > 0) {
                this.$message.warning(
                  `批量入网完成：成功 ${successCount} 辆，失败 ${failCount} 辆（未入网或验证不通过）`
                );
              } else {
                this.$message.success(`批量入网完成：成功 ${successCount} 辆`);
              }
              this.selected = [];
              this.findList();
            })
            .finally(() => {
              this.batchOnNetLoading = false;
            });
        })
        .catch(() => {});
    },
    handleDelete(row) {
      this.$confirm(
        "确认删除该车辆吗？删除后不可恢复，存在未完成运单或已绑定实际承运人时不允许删除。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          const rLoading = this.openLoading("正在删除...");
          deleteVehicleArchive(row.code)
            .then(response => {
              rLoading.close();
              this.$message({
                message: (response && response.msg) || "删除成功",
                type: "success"
              });
              this.findList();
            })
            .catch(() => {
              rLoading.close();
            });
        })
        .catch(() => {});
    },
    // ---------- 导出 ----------
    handleExport() {
      if (!this.tableData.length && !this.listQuery.total) {
        return this.$message.warning("暂无数据可导出");
      }
      const params = Object.assign({}, this.listQuery);
      ["pageNum", "pageSize", "total", "sortField", "sortOrder"].forEach(
        key => {
          delete params[key];
        }
      );
      // 日期区间控件值（xxxRange）仅用于回显，实际导出下发 xxxStart / xxxEnd
      delete params.regRange;
      delete params.authRange;
      // 能源类型支持多选：数组转逗号串（后端按 find_in_set 匹配）
      if (Array.isArray(params.energyType)) {
        params.energyType = params.energyType.join(",");
      }
      const rLoading = this.openLoading("正在导出...");
      exportVehicleArchive(params)
        .then(res => {
          rLoading.close();
          download(res, "车辆档案_" + this.formatDate(new Date()) + ".csv");
          this.$message.success("导出成功");
        })
        .catch(() => {
          rLoading.close();
        });
    },
    formatDate(d) {
      const pad = n => (n < 10 ? "0" + n : "" + n);
      return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate());
    }
  }
};
</script>

<style lang="scss" scoped>
$brand: #2e5ff0;
$brand-dark: #2049c9;
$brand-light: #edf4ff;
$brand-soft: rgba(46, 95, 240, 0.07);
$bg-page: #f5f7fa;
$card-bg: #ffffff;
$thead-bg: #f7f9fc;
$thead-color: #95a3b7;
$border-cell: #f0f1f3;
$border-soft: #e6eaf1;
$text-1: #1d1f2c;
$text-2: #667085;
$text-3: #98a2b3;
$muted: #c2c9d8;
$zebra: #f4f6f9;
$selected: #f4f8ff;
$hover: #f6f8fb;
$green: #10b981;
$green-bg: #dffbf2;
$orange: #f15a00;
$orange-bg: #fff0e4;
$red: #ef4141;
$red-bg: #fdecec;
$gray-text: #65748a;
$radius-sm: 6px;
$radius-md: 8px;
$radius-lg: 12px;

.archive-page {
  min-height: 100%;
  padding: 18px 24px 24px;
  background: $bg-page;
  font-size: 13px;
  color: $text-1;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  font-variant-numeric: tabular-nums;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .cb-table {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    cursor: pointer;
    flex: none;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.55;
    }
  }

  /* ================= 页面标题 ================= */
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    gap: 12px;
    flex-wrap: wrap;

    .page-title-group {
      display: flex;
      align-items: baseline;
      gap: 12px;
      flex-wrap: wrap;
      min-width: 0;
    }

    .page-title {
      font-size: 18px;
      font-weight: 700;
      color: #202633;
      letter-spacing: -0.3px;
      white-space: nowrap;
    }

    .page-subtitle {
      font-size: 13px;
      color: $text-3;
      font-weight: 500;
    }

    .page-actions {
      display: flex;
      gap: 10px;
      flex: none;
    }
  }

  /* ================= 通用按钮 ================= */
  .btn {
    height: 34px;
    padding: 0 16px;
    border-radius: $radius-sm;
    border: 1px solid $border-soft;
    background: $card-bg;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-weight: 500;
    color: #333333;
    white-space: nowrap;
    font-family: inherit;
    line-height: 1;

    &:hover {
      border-color: $brand;
      color: $brand;
      background: $brand-light;
    }
  }

  .btn-primary {
    background: $brand;
    color: #fff;
    border-color: $brand;
    font-weight: 600;
    box-shadow: 0 2px 6px rgba(46, 95, 240, 0.28);

    &:hover {
      background: $brand-dark;
      border-color: $brand-dark;
      color: #fff;
      box-shadow: 0 4px 12px rgba(46, 95, 240, 0.38);
    }
  }

  .btn-export {
    background: #f8fafc;
    border-color: #e2e8f0;
    color: #333333;
  }

  .btn-query {
    background: $brand;
    border-color: $brand;
    color: #fff;
    font-weight: 600;

    &:hover {
      background: $brand-dark;
      border-color: $brand-dark;
      color: #fff;
    }
  }

  .btn-plain {
    height: 32px;
    padding: 0 14px;
    font-size: 13px;
  }

  .btn-refresh {
    height: 30px;
    padding: 0 12px;
    font-size: 14px;
    color: #333333;

    i {
      margin-right: 3px;
    }
  }

  .btn-batch-onnet {
    height: 30px;
    padding: 0 12px;
    font-size: 14px;

    i {
      margin-right: 3px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.55;
    }
  }

  /* ================= 筛选面板 ================= */
  .filter-bar {
    background: $card-bg;
    padding: 14px 20px;
    border-radius: $radius-md;
    margin-bottom: 16px;
    border: 1px solid $border-soft;

    .filter-row {
      display: flex;
      gap: 12px;
      flex-wrap: nowrap;
      align-items: flex-end;
      overflow-x: auto;
      overflow-y: hidden;

      &.filter-row-bordered {
        margin-top: 12px;
        padding-top: 14px;
        border-top: 1px solid $border-cell;
      }
    }

    .filter-item {
      display: flex;
      flex-direction: column;
      gap: 5px;
      flex: 1 1 0;
      min-width: 0;

      &.filter-item-keyword {
        flex: 1.6 1 0;
      }

      &.filter-item-range {
        flex: 2.2 1 0;

        ::v-deep .el-range-editor.el-input__inner {
          width: 100%;
        }
      }

      &.filter-item-sm {
        flex: 0.8 1 0;
      }

      &.filter-item-energy {
        flex: 2 1 0;
      }

      label {
        color: $text-2;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
      }

      > input,
      > select {
        height: 32px;
        padding: 0 10px;
        border: 1px solid $border-soft;
        border-radius: $radius-sm;
        font-size: 13px;
        outline: none;
        background: $card-bg;
        color: $text-1;
        transition: all 0.2s;
        font-family: inherit;
        width: 100%;

        &:focus {
          border-color: $brand;
          box-shadow: 0 0 0 3px $brand-soft;
        }

        &::placeholder {
          color: $muted;
        }
      }

      select {
        cursor: pointer;
      }
    }

    /* 能源类型多选：el-select 与原生筛选框等宽（高度用 size=small=32px 对齐） */
    .energy-multi {
      width: 100%;
    }

    /* 标签区单行裁切：避免选中后标签换行/溢出筛选行，出现滚动条并导致筛选项跳动 */
    .energy-multi ::v-deep .el-select__tags {
      flex-wrap: nowrap;
      overflow: hidden;
    }

    .filter-actions {
      display: flex;
      gap: 8px;
      margin-left: auto;
      align-items: flex-end;
      flex: none;
    }

    .filter-adv-toggle {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      height: 32px;
      padding: 0 10px;
      border: 1px solid $border-soft;
      background: $card-bg;
      color: $text-2;
      border-radius: $radius-sm;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: all 0.2s;

      &:hover,
      &.is-open {
        border-color: $brand;
        color: $brand;
        background: $brand-soft;
      }

      .adv-chev {
        transition: transform 0.2s;
      }

      &.is-open .adv-chev {
        transform: rotate(180deg);
      }
    }
  }

  /* ================= 运力资源池卡片 ================= */
  .vehicle-card {
    background: $card-bg;
    border-radius: $radius-md;
    border: 1px solid $border-soft;
    padding: 14px 14px 0;

    .vehicle-card-top {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 2px 6px 14px;

      .vehicle-card-title {
        font-size: 15px;
        font-weight: 700;
        color: #242933;
        white-space: nowrap;
      }

      .vehicle-card-count {
        font-size: 13px;
        color: #657083;
        font-weight: 500;
        white-space: nowrap;

        strong {
          font-weight: 700;
          color: #46586e;
          padding: 0 2px;
        }
      }

      .vehicle-card-tools {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 8px;
        flex: none;
      }
    }
  }

  /* ================= 表格 ================= */
  .table-shell {
    border-radius: $radius-lg;
    background: $card-bg;
    box-shadow: 0 4px 30px rgba(46, 45, 116, 0.05);
    border: 1px solid $border-cell;
    overflow: hidden;
  }

  .table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .data-table {
    width: 100%;
    min-width: 1370px;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;

    thead {
      th {
        background: $thead-bg;
        padding: 0 12px;
        height: 56px;
        text-align: left;
        font-weight: 500;
        color: $thead-color;
        font-size: 14px;
        letter-spacing: 0.2px;
        white-space: nowrap;
        border-bottom: 1px solid $border-cell;

        &.col-check {
          width: 44px;
          text-align: center;
        }
      }
    }

    tbody {
      tr {
        height: 82px;
        background: $card-bg;

        &.row-rejected {
          background: $zebra;
        }

        &:hover {
          background: $hover;
        }

        &.row-selected {
          background: $selected;
        }
      }

      td {
        padding: 8px 12px;
        border-bottom: 1px solid rgba(240, 241, 243, 0.85);
        color: $text-1;
        vertical-align: middle;
        overflow: hidden;

        &:first-child {
          text-align: center;
          padding: 0 4px;
        }
      }

      tr:last-child td {
        border-bottom: none;
      }

      .empty-cell {
        text-align: center;
        padding: 40px 0;
        color: $muted;
        font-size: 13px;
        border-right: none;
      }
    }
  }

  /* ---------- 单元格通用 ---------- */
  /* ---------- 操作列固定右侧 ---------- */
  .data-table {
    thead {
      th:last-child {
        position: sticky;
        right: 0;
        z-index: 3;
        box-shadow: -6px 0 8px -6px rgba(46, 45, 116, 0.1);
      }
    }

    tbody {
      td.cell-actions {
        position: sticky;
        right: 0;
        z-index: 2;
        background: $card-bg;
        box-shadow: -6px 0 8px -6px rgba(46, 45, 116, 0.08);
      }

      tr.row-rejected td.cell-actions {
        background: $zebra;
      }

      tr:hover td.cell-actions {
        background: $hover;
      }

      tr.row-selected td.cell-actions {
        background: $selected;
      }
    }
  }
  .cell-pair {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;

    .cell-main {
      font-size: 12px;
      font-weight: 500;
      color: $text-1;
      white-space: normal;
      word-break: break-word;
    }

    .cell-main--plate {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      white-space: nowrap;
    }

    .cell-sub {
      font-size: 12px;
      color: $text-3;
      white-space: normal;
      word-break: break-word;
    }

    /* 仅「车型/车长」「当前实际承运人」主行加粗 13px */
    &.cell-pair--emph .cell-main {
      font-size: 13px;
      font-weight: 700;
    }
  }

  /* ---------- 车牌徽标（新能源绿牌 / 其余黄牌） ---------- */
  .plate-badge {
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 9px;
    border-radius: 4px;
    font-family: Consolas, Menlo, Monaco, monospace;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1px;
    white-space: nowrap;
    flex: none;

    &.plate-yellow {
      color: #231f04;
      background: linear-gradient(
        180deg,
        #ffde45 0%,
        #f7c90e 55%,
        #edbb00 100%
      );
      border: 1px solid #d9a800;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.35);
    }

    &.plate-green {
      color: #0b5c2e;
      background: linear-gradient(
        180deg,
        #f6fcf3 0%,
        #cdf0d6 45%,
        #8fdaa6 100%
      );
      border: 1px solid #7bc492;
    }
  }

  /* 车牌右侧状态角标（已冻结 / 已注销，竖排） */
  .plate-state-col {
    display: inline-flex;
    flex-direction: column;
    gap: 2px;
    margin-left: 5px;
    align-items: flex-start;
    flex: none;
  }

  .state-mark {
    display: inline-flex;
    align-items: center;
    height: 15px;
    padding: 0 4px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;

    &.is-frozen {
      color: #b45309;
      background: #fdf1e3;
      border: 1px solid #f6d9ac;
    }

    &.is-cancelled {
      color: #8a93a6;
      background: #f0f2f5;
      border: 1px solid #dde1e8;
    }
  }

  .energy-tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 22px;
    padding: 0 10px;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;

    &::before {
      content: "";
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: currentColor;
      flex: none;
    }

    &.tone-green {
      background: $green-bg;
      color: #0c9d70;
    }

    &.tone-blue {
      background: $brand-light;
      color: $brand;
    }

    &.tone-gray {
      background: #eef1f5;
      color: $text-2;
    }
  }

  .cell-load {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;

    &.is-loaded {
      color: $brand;
    }

    &.is-empty {
      color: $text-3;
    }
  }

  .cell-region {
    font-size: 12px;
    color: $text-2;
    white-space: normal;
    word-break: break-word;
  }

  .cell-gps {
    min-width: 0;

    .gps-line {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      font-weight: 600;
      color: $text-1;
      white-space: nowrap;

      .gps-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        flex: none;

        &.online {
          background: $green;
          box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
        }

        &.offline {
          background: $muted;
        }
      }
    }

    .gps-mini {
      font-size: 12px;
      font-weight: 700;
      padding: 1px 6px;
      border-radius: 3px;
      white-space: nowrap;

      &.mini-ok {
        background: $green-bg;
        color: #0c9d70;
      }
    }
  }

  .cert-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .cert-row {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    .cert-name {
      font-size: 12px;
      font-weight: 600;
      color: $text-2;
      white-space: nowrap;
    }

    .cert-date {
      font-family: Consolas, Menlo, Monaco, monospace;
      font-size: 12px;
      color: $text-3;
      white-space: nowrap;
    }

    .cert-days {
      margin-left: auto;
      font-family: Consolas, Menlo, Monaco, monospace;
      font-size: 12px;
      font-weight: 700;
      text-align: right;
      white-space: nowrap;

      &.ok {
        color: #0c9d70;
      }

      &.warn {
        color: $orange;
      }

      &.bad {
        color: $red;
      }
    }
  }

  .auth-tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 24px;
    padding: 0 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;

    .auth-dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: currentColor;
      flex: none;
    }

    &.tag-green {
      background: $green-bg;
      color: #0c9d70;
    }
    &.tag-orange {
      background: $orange-bg;
      color: $orange;
    }
    &.tag-red {
      background: $red-bg;
      color: $red;
    }
    &.tag-blue {
      background: $brand-light;
      color: $brand;
    }
    &.tag-gray {
      background: #eef1f5;
      color: $text-2;
    }
  }

  .mgmt-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .mgmt-row {
      display: flex;
      align-items: flex-start;

      .mgmt-label {
        color: #c6cdd6;
        font-size: 12px;
        flex: none;
      }

      .mgmt-value {
        font-weight: 500;
        color: $text-1;
        font-size: 12px;
        min-width: 0;
        word-break: break-word;
      }
    }
  }

  /* ---------- 操作列 ---------- */
  .cell-actions {
    text-align: left;

    .cell-actions-rows {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }

    .cell-actions-row {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .text-action-btn {
      height: 28px;
      border: 1px solid $border-soft;
      background: $card-bg;
      color: #303744;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: $radius-sm;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.2s;
      padding: 0 9px;
      gap: 4px;
      white-space: nowrap;
      font-family: inherit;
      line-height: 1;

      &:hover {
        border-color: $brand;
        color: $brand;
        background: $brand-light;
      }

      &.primary {
        background: $brand;
        border: none;
        color: #fff;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(46, 95, 240, 0.25);

        &:hover {
          background: $brand-dark;
          color: #fff;
          box-shadow: 0 3px 8px rgba(46, 95, 240, 0.35);
        }
      }

      &.action-more {
        padding: 0 7px 0 9px;

        .action-more-arrow {
          margin-left: 2px;
          font-size: 11px;
          transition: transform 0.18s;
        }
      }
    }
  }

  /* ---------- 审核弹窗 ---------- */
  .audit-context {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #f7f9fc;
    border-radius: $radius-sm;
    margin-bottom: 18px;

    .audit-context-label {
      font-size: 12px;
      color: $text-2;
      flex: none;
    }

    .audit-context-value {
      font-size: 14px;
      font-weight: 600;
      color: $text-1;
    }
  }

  .audit-radio-group {
    margin-bottom: 4px;
  }

  .audit-reason {
    margin-top: 14px;

    .audit-reason-title {
      font-size: 13px;
      color: $text-2;
      font-weight: 500;
      margin-bottom: 8px;
    }
  }

  /* ================= 分页 ================= */
  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 14px 20px;
    gap: 6px;
    min-width: max-content;
    flex-wrap: wrap;

    .pagination-btn {
      padding: 6px 11px;
      border: 1px solid $border-soft;
      background: $card-bg;
      border-radius: $radius-sm;
      cursor: pointer;
      font-size: 13px;
      color: #37404c;
      font-weight: 500;
      transition: all 0.2s;
      min-width: 32px;
      text-align: center;
      font-family: inherit;

      &:hover {
        border-color: $brand;
        color: $brand;
        background: $brand-light;
      }

      &.active {
        background: $brand;
        color: #fff;
        border-color: transparent;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(46, 95, 240, 0.3);
      }

      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;

        &:hover {
          background: $card-bg;
          color: #37404c;
          border-color: $border-soft;
        }
      }
    }

    .pagination-info {
      color: $text-3;
      font-size: 13px;
      font-weight: 500;
      margin-right: 8px;
    }

    .pagination-size {
      padding: 6px 10px;
      border: 1px solid $border-soft;
      border-radius: $radius-sm;
      font-size: 13px;
      color: #37404c;
      background: $card-bg;
      outline: none;
      cursor: pointer;
      font-family: inherit;
    }

    .pagination-jump {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: $text-3;
      font-weight: 500;

      input {
        width: 42px;
        padding: 6px;
        border: 1px solid $border-soft;
        border-radius: $radius-sm;
        text-align: center;
        font-size: 13px;
        outline: none;
        font-family: inherit;
        color: $text-1;
      }
    }
  }
}
</style>

<style lang="scss">
// 下拉更多菜单渲染于 body，需全局类命中
.el-dropdown-menu__item.op-danger {
  color: #d43030;

  &:hover {
    color: #fff;
    background: #d43030;
  }
}
</style>
